import { PageTitle } from "@/components/page-title";
import { InvoiceForm } from "./_form";
import { Merchant } from "@/types";

type Props = {
  merchants: Merchant[];
};

function InvoiceNew({ merchants }: Props) {
  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <PageTitle>New invoice</PageTitle>
      <InvoiceForm merchants={merchants} />
    </div>
  );
}

export default InvoiceNew;
